// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__163O6","spin":"Loading_spin__JpvJs","fullopacity":"Loading_fullopacity__La9rM"};